export default __webpack_public_path__ + "static/media/Helm of Dark Terror.89f0a27f.jpg";